export default "__VITE_ASSET__DF5aOdGs__"